/**
 * MatchGroupingControl - Segmented control for photo grouping modes
 *
 * Modes:
 * - "none" (All): Show all photos in flat grid
 * - "my_match" (My Match): Auto-filter to user's live matches
 * - "by_match" (By Match): Stack photos by match
 */
import styles from './MatchGroupingControl.module.css';

export default function MatchGroupingControl({ value, onChange }) {
  const options = [
    { value: 'none', label: 'All' },
    { value: 'my_match', label: 'My Match' },
    { value: 'by_match', label: 'By Match' },
  ];

  return (
    <div className={styles.segmentedControl}>
      {options.map((option) => (
        <button
          key={option.value}
          className={`${styles.segment} ${value === option.value ? styles.active : ''}`}
          onClick={() => onChange(option.value)}
          type="button"
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
